// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__30y-T","large":"styles_large__ln237"};